<template>
  <scrollactive
    active-class="active"
    :offset="0"
    :duration="1500"
    bezier-easing-value=".5,0,.35,1"
    :always-track="true"
    :click-to-scroll="true"
    type="String"
  >
    <nav
      class="navbar navbar-expand-md navbar-dark fixed-top bg-dark"
      id="navbar-site"
    >
      <router-link to="#banner" custom class="navbar-brand scrollactive-item">
        <img
          :src="require('@/assets/logo_wagner_ramos.png')"
          :alt="'Portfolio Wagner Ramos'"
      /></router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link to="#banner" tag="a" class="nav-link scrollactive-item"
              >Home <span class="sr-only">(current)</span></router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="#sobre" custom class="nav-link scrollactive-item"
              >Sobre</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="#jobs" custom class="nav-link scrollactive-item"
              >Jobs</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="#expertises"
              custom
              class="nav-link scrollactive-item"
              >Expertises</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="#expertises"
              custom
              class="nav-link scrollactive-item"
              >Contato</router-link
            >
          </li>
        </ul>
        <form class="form-inline mt-2 mt-md-0">
          <router-link
            :to="{ name: 'github' }"
            title="Github"
            custom
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'github']"
          /></router-link>
          <router-link
            :to="{ name: 'linkedin' }"
            title="Linkedin"
            custom
            target="_blank"
            ><font-awesome-icon :icon="['fab', 'linkedin']"
          /></router-link>
          <router-link to="/cv.pdf" title="Download CV" tag="a" target="_blank"
            ><font-awesome-icon :icon="['fa', 'file']"
          /></router-link>
        </form>
      </div>
    </nav>
  </scrollactive>
</template>

<script>
import store from "@/storeData";
import * as $ from "jquery";
export default {
  data() {
    return {
      projetos: store.projetos
    };
  },

  watch: {
    $route() {
      $("#navbarCollapse").collapse("hide");
    }
  }
};
</script>

<style scoped>
#nav {
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  border-bottom: 1px solid grey;
  z-index: 1;
}

#nav a {
  color: #f5f5f5;
  text-decoration: none;
  font-weight: bold;
}

#nav a.vue-school-active-class {
  color: #ab26ab;
}
.nav-links {
  display: flex;
}
.links {
  padding-right: 20px;
  list-style: none;
}
.links:hover {
  text-decoration: underline;
}
.logo {
  font-size: 20px;
  color: purple;
  font-weight: bold;
}
</style>
